<template>
  <div class="questions">
    <div class="questions__header">
      <div class="questions__title has-text-weight-bold	">
        Questions
      </div>
      <b-button
        :loading="questions.submitting"
        size="is-small"
        type="is-primary"
        @click="addQuestionHandler"
      >
        Add Question
      </b-button>
    </div>
    <div class="questions__body">
      <mc-dnd-list
        v-if="attached.length > 0"
        container-class="questions__list"
        :list="attached"
        :on-drop="moveQuestionHandler"
        :enable-numbering="true"
      >
        <template #item="{ item }">
          <question-item
            attached
            owner="challenges"
            :question="item"
            :type="isHintQuestion(item.id) ? 'hint' : 'question'"
          >
            <template #marker>
              <b-button
                :class="[
                  'questions__toggle-hint',
                  {
                    'questions__toggle-hint--marked': isHintQuestion(item.id)
                  }
                ]"
                size="is-small"
                @click="toggleHint(item.id)"
              >
                {{
                  isHintQuestion(item.id) ? 'Unmark as Hint' : 'Mark as Hint'
                }}
              </b-button>
            </template>
          </question-item>
        </template>
      </mc-dnd-list>
      <div v-else class="box has-text-centered">
        There are no questions attached to this challenge!
      </div>
      <div v-if="detached.length > 0" class="questions__detached">
        <div class="questions__subtitle">
          Unattached Questions
        </div>
        <question-item
          v-for="(question, index) in detached"
          :key="index"
          :attached="false"
          owner="challenges"
          :question="question"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import con from '../../store/mutationTypes';
import QuestionItem from '../../ui/QuestionItem';

export default {
  computed: {
    ...mapState(['challenges', 'questions']),
    ...mapGetters('challenges', ['attached', 'detached'])
  },
  methods: {
    ...mapActions('challenges', ['moveReference', 'toggleHint']),
    ...mapActions('questions', ['addQuestion', 'selectQuestion']),
    async addQuestionHandler() {
      try {
        await this.addQuestion('challenges');
        this.$store.commit(con.QUESTION_EDITOR_SET_NAMESPACED, {
          id: this.questions.newQuestionId,
          type: 'question'
        });
        this.selectQuestion(this.questions.newQuestionId);
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to add question!',
          type: 'is-danger'
        });
      }
    },
    async moveQuestionHandler({ fromItem, toItem }) {
      try {
        const from = `questions/${fromItem.id}`;
        const to = `questions/${toItem.id}`;
        await this.moveReference({ from, to });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to move question!',
          type: 'is-danger'
        });
      }
    },
    isHintQuestion(questionId) {
      return this.challenges.selected.details.hintQuestionId === questionId;
    }
  },
  components: {
    QuestionItem
  }
};
</script>

<style lang="scss" scoped>
.questions {
  margin-bottom: 1.5rem;

  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
  }

  &__title {
    flex: 1 0 0;
    margin-right: 0.5rem;
  }

  &__body {
    background-color: #ffffff;
    border: 1px solid $border-color;
  }

  &__detached {
    margin-top: 1rem;
    padding: 0.5rem;
  }

  &__list {
    & /deep/ .dnd {
      &__draggable {
        box-shadow: none;
        border-bottom: 1px solid $border-color;

        &:not(:last-child) {
          margin-bottom: 0;
        }
      }

      &__draggable-handle {
        margin-right: 0;
        margin: 0 0.5rem;
      }
    }
  }

  &__toggle-hint {
    margin-right: 0.5rem;
  }

  &__subtitle {
    margin-bottom: 0.5rem;
  }
}
</style>
